import React, { useContext, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import {
  Avatar,
  Box,
  Button,
  Container,
  CssBaseline,
  Typography,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { ConfirmCodeInput } from './ConfirmCodeInput';
import { AuthContext } from './AuthContextProvider';
import { UserListDialog } from './UserListDialog';

const StyledFormBox = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 0.5em;
`;

const VerifyCode = (props) => {
  const { history, location } = props;
  const { message } = location?.state ?? {};

  const [code, setCode] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [openUsersList,setOpenUsersList ] = useState(false);
  const users = useRef([]);

  const { verify: contextVerify, verifyCode } = useContext(AuthContext);

  useEffect(() => {
    if (!props?.location?.state) {
      history.replace('/login');
    }
  }, [history, props?.location?.state]);

  const onCloseDialog =()=> setOpenUsersList (false);

  const verify = (event) => {
    event.preventDefault();

    if (code.length === 0) {
      setErrorMessage('Please enter the Verification Code.');
    } else if (code.length !== 5) {
      setErrorMessage('Please enter 5 digits.');
      setCode('');
    }
    else{
      verifyCode(code)
        .then((userList) => {
          if(userList.length > 1){
          users.current = userList;
          setOpenUsersList (users.current.length > 1);
          }
          else{
            users.current = userList;
            onUserSelect(users.current[0]?.Id);
          }
    })
        .catch((err) => {
          setCode('');
          setErrorMessage(err.message);
        });
    } 
  };

  const onUserSelect = (userId) => {
    contextVerify(userId)
      .then(({ redirectUri }) => history.push(redirectUri))
      .catch((err) => {
        setErrorMessage(err.message);
      });
}

  const codeChange = (e) => {
    setErrorMessage('');
    setCode(e.target.value);
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      {
        openUsersList && <UserListDialog onClose ={onCloseDialog} onUserSelect={onUserSelect} users ={users.current}/>
      }
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: '#1565c0' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <Typography variant="subtitle1">{message}</Typography>
        <StyledFormBox component="form" onSubmit={verify}>
          <ConfirmCodeInput
            maxLength={5}
            onChange={codeChange}
            value={code}
            onPressEnter={verify}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Verify
          </Button>
        </StyledFormBox>
        <Typography
          style={{ color: 'red' }}
          variant="body2"
          display="block"
          gutterBottom
        >
          {errorMessage}
        </Typography>
      </Box>
    </Container>
  );
};

export { VerifyCode };
